var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center px-2"},[_c('v-icon',{staticClass:"static-gradient-background background-clip-icon rounded-circle pa-1"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"text-body-1 item text-no-wrap text--darken-3 pl-1"},[_vm._v(" "+_vm._s(_vm.service)+" "),_c('b',[_vm._v(_vm._s(_vm.count))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }